import globalPhoto from '../assets/photography/andrea-piacquadio-road-trip-friends.jpg';
import highwayPhoto from '../assets/photography/maureen-wahu-nairobi-highway.jpg';
import { BUSINESS_DASHBOARD_URL } from '../data/navigation';
import './SupportingStories.css';

/**
 * Two supporting bands that sit between the product proof and the closing CTA,
 * and give the `Stories` and `Business` navigation links real destinations.
 */
export const SupportingStories = () => (
  <div className="tl-band">
    <div className="tl-shell tl-band__grid">
      <section className="tl-band__card tl-reveal" id="stories" aria-labelledby="tl-stories-heading">
        <figure className="tl-band__figure">
          <img
            className="tl-photo"
            src={globalPhoto}
            alt="Friends leaning out of a car window on a road trip together."
            width={1098}
            height={750}
            loading="lazy"
            decoding="async"
          />
        </figure>
        <div className="tl-band__copy">
          <p className="tl-eyebrow">Stories</p>
          <h2 id="tl-stories-heading">Every group has its own road.</h2>
          <p className="tl-lede">
            Weekend escapes, family trips or cross-country adventures—Tulink helps everyone leave
            together, stay together and arrive together.
          </p>
        </div>
      </section>

      <section
        className="tl-band__card tl-reveal"
        id="business"
        aria-labelledby="tl-business-heading"
      >
        <figure className="tl-band__figure">
          <img
            className="tl-photo"
            src={highwayPhoto}
            alt="Traffic moving along a Nairobi highway in the late afternoon."
            width={1125}
            height={750}
            loading="lazy"
            decoding="async"
          />
        </figure>
        <div className="tl-band__copy">
          <p className="tl-eyebrow">Business</p>
          <h2 id="tl-business-heading">Keep every vehicle accounted for.</h2>
          <p className="tl-lede">
            Plan and follow journeys for teams, tour groups and fleets from one shared dashboard.
          </p>
          <a className="tl-button tl-button--quiet tl-band__cta" href={BUSINESS_DASHBOARD_URL}>
            Explore Tulink for Business
          </a>
        </div>
      </section>
    </div>
  </div>
);
